import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AuthUser, UserAddress } from './authTypes';
import { encryptData } from 'apps/portal/online/utils/Crypto';

export interface AuthState {
  isLogin: boolean;
  isGuest: boolean;
  isGuestFormFilled: boolean;
  isSubscribed: boolean;
  user: AuthUser;
  guestEmail?: string | null;
  checkoutlogin: boolean;
  signedUp: boolean;
  userAlreadyExists: boolean | null;
  guestSessionId: string | null;
  pseudoId: string | null;
  signoutClicked: boolean;
  tempPhoneNumber: string | null;
  redirectFromNotFound: boolean;
  userAllergens?: number[] | null;
}

const initialState: AuthState = {
  // default values for user
  isLogin: false,
  isGuest: true,
  isSubscribed: false,
  isGuestFormFilled: false,
  guestEmail: null,
  user: {
    fName: null,
    lName: null,
    email: null,
    phone: null,
    username: null,
    address: {},
    userLatitude: null,
    userLongitude: null,
  },
  checkoutlogin: false,
  signedUp: false,
  userAlreadyExists: null,
  guestSessionId: null,
  pseudoId: null,
  signoutClicked: false,
  tempPhoneNumber: null,
  redirectFromNotFound: false,
  userAllergens: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // actions to update state
    logoutUser: () => initialState,

    loginUser: (state, action: PayloadAction<any>) => {
      for (const key in action?.payload) {
        if (key in state) {
          if (key === 'user' && typeof action?.payload[key] === 'object') {
            state.user = { ...state.user, ...action?.payload[key] };
            continue;
          } else {
            (state as any)[key] = action?.payload[key];
          }
        }
      }
    },
    updateUserAuth: (state, action: PayloadAction<any>) => {
      for (const key in action?.payload) {
        if (key in state) {
          if (key === 'user' && typeof action?.payload[key] === 'object') {
            state.user = { ...state.user, ...action?.payload[key] };
            continue;
          } else {
            (state as any)[key] = action?.payload[key];
          }
        }
      }
    },
    setUserAddressInfo: (state, action: PayloadAction<any>) => {
      const newAddress: Partial<UserAddress> = {};
      for (const key in action?.payload.address) {
        const k = key as keyof UserAddress;
        newAddress[k] = encryptData(action?.payload.address[key]);
      }
      state.user = { ...state.user, address: { ...state.user.address, ...newAddress } };
    },
    removeUserAddressInfo: (state) => {
      state.user = { ...state.user, address: {}, userLatitude: null, userLongitude: null };
    },
  },
});

// Action creators are generated for each case reducer function
export const { loginUser, logoutUser, updateUserAuth, setUserAddressInfo, removeUserAddressInfo } = authSlice.actions;

export default authSlice.reducer;
